import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppContext } from '../app/context';
import { SystemInfoService } from './api.services';
import { LicenseInfo, SystemInfo } from './models/support.models';

@Injectable({
  providedIn: 'root'
})
export class SupportService {
  readonly appContext = inject(AppContext);

  constructor(private systemInfoService: SystemInfoService) { }

  public provideSystemInfo(): Observable<SystemInfo> {
    return this.systemInfoService.getSystemInfo().pipe(
      map(x => {
        return {
          ...x,
          region: this.appContext.user()?.region
        };
      }),
    );
  }

  public provideLicenseInfo(): Observable<LicenseInfo> {
    return this.systemInfoService.getLicenseInfo();    
  }
}
